import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Calendar,
  Filter,
  Layers,
  FileMinus,
  RotateCcw,
  User,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table, DatePicker, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getItemWiseConsumptionReport,
  getMenuItemConsumptionReport,
} from "../../../services/ReportApiService";
import { Filterclass } from "../../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../../redux/helper";
import dayjs from "dayjs";
import {
  fetchCounter,
  fetchSection,
  fetchProduct,
  fetchCategory,
  fetchGroup,
  fetchSettings,
} from "../../../redux/userSetting";
import { fetchUser } from "../../../redux/userServices";
import {
  exportPDF,
  exportExcel,
  printReport,
} from "../../../core/utils/StockReportUtils";
import { setheadertoggle } from "../../../redux/toggle";
import LoadingUtils from "../../../core/utils/LoadingUtils";

const { TabPane } = Tabs;

const ConsumptionReport = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [itemWiseData, setItemWiseData] = useState([]);
  const [menuItemData, setMenuItemData] = useState([]);
  const [productval, setproductval] = useState(null);
  const [categoryval, setscategoryval] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [sectionval, setsectionval] = useState(null);
  const [counterval, setcounterval] = useState(null);
  const [waiter, setwaiter] = useState(null);

  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { productList, categoryList, groupList, sectionList, counterList } =
    useSelector((state) => state.usersetting);
  const { UserList } = useSelector((state) => state.userservice);
  const currfmt = useSelector((state) => {
    const match = state.usersetting?.settingList?.currencyFormat
      ?.toString()
      ?.match(/\.0+/);
    return match ? match[0]?.length - 1 : 0;
  });

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  // Load filter dropdown option lists once a branch is available.
  useEffect(() => {
    if (!branch?.guid) return;
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCounter(branch.guid));
    dispatch(fetchProduct(branch));
    dispatch(fetchCategory(branch.guid));
    dispatch(fetchGroup(branch.guid));
    dispatch(fetchUser());
    dispatch(fetchSettings(branch));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch?.guid]);

  // Refetch both reports whenever the branch, date range, or any filter changes.
  useEffect(() => {
    handleReportList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    branch,
    fromDate,
    toDate,
    sectionval,
    counterval,
    waiter,
    productval,
    categoryval,
    selectedGroup,
  ]);

  const handleReportList = async () => {
    if (!branch) return;
    setloading(true);
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = dayjs(fromDate).format("YYYY-MM-DD");
    Filters.ToDate = dayjs(toDate).format("YYYY-MM-DD");
    Filters.Section = sectionval?.value || "";
    Filters.Counter = counterval?.value || "";
    Filters.User = waiter?.value || "";
    Filters.Product = productval?.value || "";
    Filters.Category = categoryval?.value || "";
    Filters.Group = selectedGroup?.value || "";
    Filters.DayClosed = false;

    try {
      const [itemWiseRes, menuItemRes] = await Promise.all([
        getItemWiseConsumptionReport(Filters),
        getMenuItemConsumptionReport(Filters),
      ]);

      const itemRows = (
        itemWiseRes?.data?.consumptionReportDetail || []
      ).map((item, idx) => ({
        key: idx,
        slNo: idx + 1,
        itemName: item.product?.name || "",
        unit: item.unit?.name || "",
        quantity: item.quantity || 0,
        rate: item.rate || 0,
        total: item.total || 0,
        rawMaterials: (item.rawMaterials || []).map((rm, i) => ({
          key: `${idx}-${i}`,
          slNo: rm.slNo ?? i + 1,
          itemName: rm.product?.name || "",
          unit: rm.unit?.name || "",
          quantity: rm.quantity || 0,
          rate: rm.rate || 0,
          total: rm.total || 0,
        })),
      }));
      setItemWiseData(itemRows);

      const menuRows = (
        menuItemRes?.data?.menuItemConsumptionReportDetail || []
      ).map((rm, idx) => ({
        key: idx,
        slNo: rm.slNo ?? idx + 1,
        itemName: rm.product?.name || "",
        unit: rm.unit?.name || "",
        quantity: rm.quantity || 0,
        rate: rm.rate || 0,
        total: rm.total || 0,
      }));
      setMenuItemData(menuRows);
    } catch (error) {
      console.error("Error fetching Consumption Report", error);
    } finally {
      setloading(false);
    }
  };

  const product = productList?.map((e) => ({ value: e.guid, label: e.name }));
  const category = categoryList?.map((e) => ({ value: e.guid, label: e.name }));
  const group = groupList?.map((e) => ({ value: e.guid, label: e.name }));
  const section = sectionList?.map((e) => ({ value: e.guid, label: e.name }));
  const counter = counterList?.map((e) => ({ value: e.guid, label: e.name }));
  const userroles = UserList?.map((e) => ({ value: e.guid, label: e.name }));

  // ---- Item wise Consumption Report (tab 1) ----
  const filteredItemWise = itemWiseData?.filter((row) => {
    if (!searchText) return true;
    const text = searchText.toLowerCase();
    const itemMatch = row.itemName?.toLowerCase().includes(text);
    const rawMatch = row.rawMaterials?.some((rm) =>
      rm.itemName?.toLowerCase().includes(text)
    );
    return itemMatch || rawMatch;
  });

  // Flatten each item + its raw materials + a subtotal row into one
  // continuous table, matching the Excel/PDF layout (no expand/collapse).
  const displayRows = filteredItemWise?.flatMap((item) => {
    const subtotal = (item.rawMaterials || []).reduce(
      (s, rm) => s + (rm.total || 0),
      0
    );
    return [
      { ...item, rowType: "item" },
      ...(item.rawMaterials || []).map((rm) => ({ ...rm, rowType: "raw" })),
      {
        key: `subtotal-${item.key}`,
        rowType: "subtotal",
        itemName: "Subtotal",
        total: subtotal,
      },
    ];
  });

  const displayColumns = [
    {
      title: "Sl No",
      key: "slNo",
      dataIndex: "slNo",
      render: (v, record) => (record.rowType === "item" ? v : ""),
    },
    {
      title: "Item Name",
      key: "itemName",
      dataIndex: "itemName",
      render: (v, record) => (
        <span
          style={{
            paddingLeft: record.rowType === "raw" ? 24 : 0,
            fontWeight: record.rowType === "raw" ? 400 : 600,
          }}
        >
          {v}
        </span>
      ),
    },
    { title: "Unit", key: "unit", dataIndex: "unit" },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
    {
      title: "Rate",
      key: "rate",
      dataIndex: "rate",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
    {
      title: "Total",
      key: "total",
      dataIndex: "total",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
  ];

  // ---- Consumption Report based on Menu Items (tab 2) ----
  const filteredMenuItems = menuItemData?.filter((row) => {
    if (!searchText) return true;
    return row.itemName?.toLowerCase().includes(searchText.toLowerCase());
  });

  const menuColumns = [
    { title: "Sl No", key: "slNo", dataIndex: "slNo" },
    { title: "Raw Material", key: "itemName", dataIndex: "itemName" },
    { title: "Unit", key: "unit", dataIndex: "unit" },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
    {
      title: "Rate",
      key: "rate",
      dataIndex: "rate",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
    {
      title: "Total",
      key: "total",
      dataIndex: "total",
      align: "right",
      render: (v) => (typeof v === "number" ? v.toFixed(currfmt) : ""),
    },
  ];

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);
    setToDate(null);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const handleSearch = (e) => setSearchText(e.target.value);
  const handleRefresh = () => handleReportList();
  const handleReset = () => {
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setproductval(null);
    setscategoryval(null);
    setSelectedGroup(null);
    setsectionval(null);
    setcounterval(null);
    setwaiter(null);
  };

  const getActiveTabData = () => {
    if (activeTab === "2") {
      const fieldMapping = {
        "Sl No": "slNo",
        "Raw Material": "itemName",
        Unit: "unit",
        Quantity: "quantity",
        Rate: "rate",
        Total: "total",
      };
      return {
        data: filteredMenuItems,
        columns: menuColumns,
        fieldMapping,
        Rname: "Consumption Report based on Menu Items",
        currfmt,
      };
    }

    const fieldMapping = {
      "Sl No": "slNo",
      "Item Name": "itemName",
      Unit: "unit",
      Quantity: "quantity",
      Rate: "rate",
      Total: "total",
    };
    const exportRows = displayRows?.map((row) => ({
      slNo: row.rowType === "item" ? row.slNo : "",
      itemName: row.rowType === "raw" ? `   ${row.itemName}` : row.itemName,
      unit: row.rowType === "subtotal" ? "" : row.unit,
      quantity: row.rowType === "subtotal" ? "" : row.quantity,
      rate: row.rowType === "subtotal" ? "" : row.rate,
      total: row.total,
    }));

    return {
      data: exportRows,
      columns: displayColumns,
      fieldMapping,
      Rname: "Item Wise Consumption Report",
      currfmt,
    };
  };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Consumption Report</h4>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportPDF(getActiveTabData, null, "Consumption Report")
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                  <button
                    onClick={() =>
                      exportExcel(getActiveTabData, null, "Consumption Report")
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                  <button
                    onClick={() =>
                      printReport(getActiveTabData, null, "Consumption Report")
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={() => renderTooltip("Refresh")}>
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Collapse")}>
                  <Link
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                          format="DD/MM/YYYY"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          value={toDate}
                          onChange={handleToDateChange}
                          disabled={!fromDate}
                          format="DD/MM/YYYY"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={() => handleReportList()}
                    >
                      <i data-feather="search" className="feather-search" /> search
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button className="btn btn-reset rounded-2" onClick={handleReset}>
                      <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
                    id="filter_search"
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                    </span>
                  </Link>
                </div>
              </div>
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Layers className="info-img" />
                        <Select
                          className="img-select"
                          options={product}
                          value={productval}
                          onChange={setproductval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Product"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={category}
                          value={categoryval}
                          onChange={setscategoryval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Category"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={group}
                          value={selectedGroup}
                          onChange={setSelectedGroup}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Group"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={section}
                          value={sectionval}
                          onChange={setsectionval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Section"
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={counter}
                          value={counterval}
                          onChange={setcounterval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Counter"
                        />
                      </div>
                    </div> */}
                    {/* <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          options={userroles}
                          value={waiter}
                          onChange={setwaiter}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="User"
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane tab="Item wise Consumption Report" key="1">
                  <div className="table-responsive product-list">
                    <Table
                      columns={displayColumns}
                      dataSource={displayRows}
                      ref={tableRef}
                      id="table-to-export"
                      rowKey="key"
                      rowClassName={(record) =>
                        record.rowType === "subtotal" ? "fw-bold" : ""
                      }
                      pagination={{
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${displayRows?.length} rows`,
                      }}
                    />
                  </div>
                </TabPane>
                <TabPane tab="Consumption Report based on Menu Items" key="2">
                  <div className="table-responsive product-list">
                    <Table
                      columns={menuColumns}
                      dataSource={filteredMenuItems}
                      id="table-to-export"
                      rowKey="key"
                      pagination={{
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${filteredMenuItems?.length} items`,
                      }}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsumptionReport;
